import { getDatabase, push, ref, set } from "firebase/database";
import moment from "moment";
import { TextsProps } from "../database/txt.interface";
import { ServicosProps } from "../interfaces/config.interface";
import { Exercicios2Props } from "../interfaces/exercicio.interface";
import { PacientesProps, UserProps } from "../interfaces/pacientes.interface";
import { AppActions } from "../store/ducks/app";
import { AuthActions } from "../store/ducks/auth";
import { TypesPermission, TypesDivision, TypesLanguage } from "./types";
import { useSelector } from "react-redux";
import { DashBoardActions } from "../store/ducks/dashboard";
import { Dispatch } from "redux";
import { loadStorage, persistStorage } from "./base_async_storage";
import * as Sentry from "@sentry/react";
import { PacAvalActions } from "../store/ducks/manage_pac_aval";
import { AnamneseActions } from "../store/ducks/anamnese";
import { AddPacAvalActions } from "../store/ducks/add_pac_aval";
import { AmplitudeLog } from "./amplitude";
import { ConfigsActions } from "../store/ducks/configs";

export function getGroupingSide(side: any, current_language: TextsProps) {
	if (side == "D") {
		return current_language?.hemisferio_direito;
	}
	if (side == "E") {
		return current_language?.hemisferio_esquerdo;
	}
	if (side == "B") {
		return current_language?.hemisferio_bilateral;
	}
	if (side == "S") {
		return current_language?.sem_hemisferio;
	}
}

export function getElementsExers(
	exer: Exercicios2Props,
	type: any,
	T: any,
	current_language: TextsProps,
	language: any
) {
	const DEB = type == TypesDivision.DEB ? ["D", "E", "B"] : ["S"];
	const aux_tipo = T.split("");

	const arr: any = [];

	aux_tipo.forEach((e: any) => {
		if (DEB.includes(e)) {
			arr.push({
				title:
					e == "D"
						? current_language?.hemisferio_direito
						: e == "E"
						? current_language?.hemisferio_esquerdo
						: e == "B"
						? current_language?.hemisferio_bilateral
						: current_language?.sem_hemisferio,
				value: e,
				exercice_id: exer?.ID_EXERCICIO,
				grupo: exer?.ID_AGRUPAMENTO,
				name:
					language == TypesLanguage.PT
						? exer?.EXERCICIO_TITULO_PT
						: language == TypesLanguage.EN
						? exer?.EXERCICIO_TITULO_EN
						: exer?.EXERCICIO_TITULO_ES,
			});
		}
	});
	return arr;
}

export function getPermission(
	config_servicos: ServicosProps[],
	type: any,
	dispatch?: any
) {
	return config_servicos[type] || false;
}

export function getTimeExecFunction(
	tempInitial: number,
	tempFinal: number,
	description: string,
	user?: UserProps
) {
	const dataAtual = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
	const result = tempFinal - tempInitial;
	const data = {
		user: user,
		moment: dataAtual,
		resultTime: result,
	};

	try {
		const firebaseDataBase = getDatabase();
		push(ref(firebaseDataBase, description), {
			id_user: data?.user?.ID_USUARIO,
			current_date: data.moment,
			ResultTime: data.resultTime,
		});
	} catch (error) {
		console.log("Seus dados não foram enviados", error);
	}
}

export function getTimeout(
	tempInitial: number,
	tempFinal: number,
	description: string,
	user?: UserProps
) {
	const dataAtual = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
	const result = tempFinal - tempInitial;
	const timeout = {
		user: user,
		moment: dataAtual,
		timeout: result,
	};

	try {
		const firebaseDataBase = getDatabase();
		if (result >= 60000) {
			push(ref(firebaseDataBase, description), {
				id_user: timeout?.user?.ID_USUARIO,
				current_date: timeout.moment,
				timeout: timeout.timeout,
			});
		}
	} catch (error) {
		console.log("Seus dados não foram enviados", error);
	}
}

/**
 *
 * @param pagina_desejada Number of the page you want to load the patient list
 * @param numero_de_paginas Represents the total number of existing pages (total number of patients divided by 6 - Number of patients per page)
 * @param dispatch redux dispatch (used to trigger an action)
 */
export function MudarPagina(
	pagina_desejada: number,
	numero_de_paginas: number,
	dispatch: Dispatch,
	value?: Array<number>,
	SearchName?: any,
	quantidade_usuarios_por_pagina?: number
) {
	//Caso queira alterar o numero de pacientes por pagina
	//Alterar também no ducks dashboard para primeira requisição
	const usuarios_por_pagina = quantidade_usuarios_por_pagina ?? 6;
	const usuarios_na_pagina = [];

	dispatch(DashBoardActions.set_current_page_patient(pagina_desejada));

	if (pagina_desejada != null && pagina_desejada <= numero_de_paginas) {
		const indiceInicial = (pagina_desejada - 1) * usuarios_por_pagina;
		const indiceFinal = indiceInicial + usuarios_por_pagina;
		for (let i = indiceInicial; i <= indiceFinal; i++) {
			usuarios_na_pagina.push(i);
		}

		const filtros_paginacao = {
			inicio: usuarios_na_pagina[0],
			fim: usuarios_na_pagina[usuarios_por_pagina],
			filtros: [
				{ tipo: "USUARIO_EXCLUIDO", valor: "N" },
				{ tipo: "USUARIO_NIVEL", valor: value },
			],
		};
		if (SearchName != "") {
			filtros_paginacao.filtros.push({
				tipo: "USUARIO_NOME",
				valor: SearchName,
			});
		}

		dispatch(DashBoardActions.set_filtros_pacintes_request(filtros_paginacao));
		dispatch(DashBoardActions.paciente_request());

		if (value?.includes(1) && value?.includes(2)) {
			dispatch(DashBoardActions.set_current_page_evaluator(pagina_desejada));
			dispatch(
				DashBoardActions.set_filtros_avaliadores_request(filtros_paginacao)
			);
			dispatch(DashBoardActions.avaliadores_request());
		}
	} else {
		console.log(`A página ${pagina_desejada} não existe.`);
	}
}

export async function getEvaluatedPatients(paciente: PacientesProps) {
	let evaluatedPatients: number[] | null = [];

	evaluatedPatients = await loadStorage("evaluated_patients");

	if (!evaluatedPatients?.includes(paciente?.ID_USUARIO)) {
		evaluatedPatients?.push(paciente?.ID_USUARIO);

		persistStorage({
			res: evaluatedPatients,
			tag: "evaluated_patients",
		});
	}
}

export function setMaskPhone(text: string) {
	enum MaskProps {
		text = "text",
		justNumbers = "justNumbers",
	}
	const justNumbers = text.replace(/\D/g, "");

	const handleMask = {
		text: text,
		justNumbers: justNumbers,
	};

	const mask = handleMask[
		text?.length >= 2 ? MaskProps?.justNumbers : MaskProps?.text
	].replace(/^(\d{0,2})?(\d{0,5})?(\d{0,4})?/, (match, ddd, prefix, sufix) => {
		return (
			(ddd ? `(${ddd}` : "") +
			(prefix ? `) ${prefix}` : "") +
			(prefix && sufix ? "-" : "") +
			(sufix || "")
		);
	});

	return mask;
}

export function setMaskCPF(input: string) {
	const justNumbers = input.replace(/\D/g, "");
	const mask = justNumbers.replace(
		/^(\d{0,3})?(\d{0,3})?(\d{0,3})?(\d{0,2})?/,
		(match, group1, group2, group3, group4) => {
			return (
				(group1 ? `${group1}.` : "") +
				(group2 ? `${group2}.` : "") +
				(group3 ? `${group3}-` : "") +
				(group4 || "")
			);
		}
	);

	if (mask.slice(-1) === "-" || mask.slice(-1) === ".") {
		return mask.slice(0, -1);
	}

	return mask;
}
export function setMaskNascimento(input: string) {
	
	const cleaned = input.replace(/\D/g, '');

	let formatted = cleaned;
	if (cleaned.length > 2) {
	  formatted = `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
	}
	if (cleaned.length > 4) {
	  formatted = `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4)}`;
	}
	return formatted;
}

export function setMaskBirthDate(input: string): string {
	const justNumbers = input.replace(/\D/g, "");

	const match = justNumbers.match(/^(\d{0,2})(\d{0,2})(\d{0,4})/);
	if (!match) return "";

	let [_, day, month, year] = match;

	// Limita valores apenas se completos
	if (day) {
		const dayNum = parseInt(day, 10);
		if (!isNaN(dayNum)) {
			day = Math.min(dayNum, 31).toString().padStart(day.length, "0");
		}
	}

	if (month) {
		const monthNum = parseInt(month, 10);
		if (!isNaN(monthNum)) {
			month = Math.min(monthNum, 12).toString().padStart(month.length, "0");
		}
	}

	if (year && year.length === 4) {
		const yearNum = parseInt(year, 10);
		const currentYear = new Date().getFullYear();
		if (yearNum < 1900) {
			year = "1900";
		} else if (yearNum > currentYear) {
			year = currentYear.toString();
		}
	}

	const masked =
		(day ? `${day}` : "") +
		(month ? `/${month}` : "") +
		(year ? `/${year}` : "");

	return masked;
}

export function setMaskWeight(input: string): string {
	const justNumbers = input.replace(/\D/g, "");

	// Preenche à esquerda com zeros se tiver menos de 3 dígitos
	const padded = justNumbers.padStart(3, "0");

	const intPart = padded.slice(0, -2);
	const decimalPart = padded.slice(-2);

	return `${parseInt(intPart, 10)},${decimalPart}`;
}

export function setMaskHeight(input: string): string {
	const justNumbers = input.replace(/\D/g, "");

	const mask = justNumbers.replace(
		/^(\d{0,1})(\d{0,2})/,
		(_, intPart, decimalPart) => {
			return (
				(intPart ? `${intPart}` : "") + (decimalPart ? `,${decimalPart}` : "")
			);
		}
	);

	return mask;
}
export function formatCNPJ(value: string): string {
	const cleaned = value.replace(/\D/g, "");

	const cnpjFormatted = cleaned
		.replace(/^(\d{2})(\d)/, "$1.$2")
		.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
		.replace(/\.(\d{3})(\d)/, ".$1/$2")
		.replace(/(\d{4})(\d)/, "$1-$2")
		.slice(0, 18);

	return cnpjFormatted;
}

export function formatDominant(dominant: string, current_language: TextsProps) {
	let setDominant = "";
	if (dominant === "E") setDominant = current_language?.canhoto;
	if (dominant === "D") setDominant = current_language?.destro;
	return setDominant;
}

export function formatDominantForSave(
	dominant: string,
	current_language: TextsProps
) {
	let setDominant = "";
	if (dominant === current_language?.canhoto) setDominant = "E";
	if (dominant === current_language?.destro) setDominant = "D";
	return setDominant;
}
export function formatCreditCardNumber(input: string) {
	if (!input) return "";
	const digitsOnly = input.replace(/\D/g, "");
	const formatted = digitsOnly.match(/.{1,4}/g)?.join(" ") || "";
	return formatted;
}
export function maskMonth(input: string) {
	if (!input) return "";
	const somenteNumeros = input.replace(/\D/g, "");
	return somenteNumeros.slice(0, 2);
}
export function maskYear(input: string) {
	if (!input) return "";
	const somenteNumeros = input.replace(/\D/g, "");
	return somenteNumeros.slice(0, 4);
}
export function maskCvv(input: string) {
	if (!input) return "";
	const somenteNumeros = input.replace(/\D/g, "");
	return somenteNumeros.slice(0, 3);
}

const REDACTED_VALUE = "[REDACTED]";
const SENSITIVE_KEY_PATTERN =
	/(senha|password|token|authorization|cvv|cartao_numero)/i;

/**
 * Percorre um valor recursivamente e substitui por `"[REDACTED]"` qualquer
 * chave cujo nome bata com um padrão sensível (senha/password/token/...),
 * em qualquer nível de aninhamento. Usado antes de enviar `extra`/contexto
 * de erro para o Sentry, para nunca vazar credenciais em texto puro.
 */
export function redactSensitiveData<T>(value: T): T {
	if (Array.isArray(value)) {
		return value.map((item) => redactSensitiveData(item)) as unknown as T;
	}

	if (value !== null && typeof value === "object") {
		const result: Record<string, unknown> = {};
		for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
			result[key] = SENSITIVE_KEY_PATTERN.test(key)
				? REDACTED_VALUE
				: redactSensitiveData(val);
		}
		return result as T;
	}

	return value;
}

/**
 * Envia logs de erro para a Sentry em ambiente de produção ou exibe no DevTools quando em ambiente local.
 *
 * Esta função centraliza o tratamento de erros, permitindo capturar exceções com contexto adicional.
 * Em ambiente de desenvolvimento (`localhost`), os logs são exibidos no console para facilitar o debug.
 * Opcionalmente, também é possível forçar o envio para a Sentry mesmo em ambiente local.
 *
 * @param {unknown} error - (Obrigatório) Objeto do erro capturado. Idealmente uma instância de `Error`.
 * @param {Object} [context={}] - (Opcional) Objeto contendo informações adicionais para enriquecer o log.
 * @param {string} [context.message] - Mensagem descritiva do erro.
 * @param {Record<string, string>} [context.tags] - Tags de categorização, como nome do endpoint ou componente.
 * @param {Record<string, any>} [context.payload] - Dados extras úteis para debug, como payloads ou identificadores.
 * @param {boolean} [sendLocalErrorForSentry=false] - Se verdadeiro, envia o log para a Sentry mesmo em ambiente local.
 */

export function sendErrorSentryOrLocalHost(
	error: unknown,
	context: {
		message?: string;
		tags?: { endpoint: string; file: string; failure_reason?: string };
		payload?: Record<string, any>;
	} = {},
	sendLocalErrorForSentry: boolean = false
) {
	const isDev = process.env.NODE_ENV !== "production";

	if (isDev && !sendLocalErrorForSentry) {
		console.error(" *****[DEBUG - ERRO LOCAL]***** ", {
			mensagem: context.message,
			erro: error,
			tags: context.tags,
			payload: context.payload || "Dado não informado",
		});
	} else {
		const safePayload = context.payload
			? redactSensitiveData(context.payload)
			: context.payload;

		if (error instanceof Error) {
			Sentry.captureException(error, {
				tags: context.tags,
				extra: safePayload,
			});
		} else {
			Sentry.captureMessage(context.message || "Erro desconhecido", {
				tags: context.tags,
				extra: safePayload,
			});
		}
	}
}

export const handlePaciente = (
	paciente: any,
	dispatch: Dispatch,
	config_servicos: any
) => {
	const obj = {
		name: paciente?.USUARIO_NOME,
		value: "paciente",
	};
	const payload = {
		ID_USUARIO: paciente?.ID_USUARIO,
		txDataHora: moment(new Date()).format("YYYY-MM-DD HH:mm:ss").toString(),
	};
	dispatch(AppActions.set_open_paciente(paciente));
	dispatch(PacAvalActions.set_perfil_anamnese_patient(paciente?.ID_USUARIO));
	dispatch(AnamneseActions.set_relatorio_qualidade_vida_history(null));
	dispatch(AppActions.set_open_barraSuperior(obj));
	dispatch(AppActions.set_confirm_close_modal_edit(true));
	dispatch(AddPacAvalActions.set_recorrente(payload));
	AmplitudeLog("paci_mais_visitados", {
		body: {
			paciente: payload,
		},
	});
	const permissionAssessmentPhysical: any = getPermission(
		config_servicos as ServicosProps[],
		TypesPermission.SERVICO_ANAMNESE_FISICA
	);
	if (!permissionAssessmentPhysical) {
		dispatch(ConfigsActions.set_close_modal_upgrade_and_goback(true));
		dispatch(
			ConfigsActions.set_physical_anamnesis_verification_by_the_most_visited_patients(
				permissionAssessmentPhysical
			)
		);
	}
};

function parseQuarterLabel(label: any) {
  const m = /^Q([1-4])\/(\d{4})$/.exec(String(label).trim());
  if (!m) throw new Error("Formato inválido. Use 'Qn/YYYY'.");
  return { q: Number(m[1]), year: Number(m[2]) };
}

function incrementQuarterLabel(label: any, steps = 1) {
  const { q, year } = parseQuarterLabel(label);
  const idx = year * 4 + (q - 1) + steps;      
  const newYear = Math.floor(idx / 4);
  const newQ = (idx % 4) + 1;
  return `Q${newQ}/${newYear}`;
}


function quarterFromMoment(mm: moment.Moment) {
  const q = Math.floor(mm.month() / 3) + 1;
  return { q, year: mm.year(), label: `Q${q}/${mm.year()}` };
}



/**
 * getNextQuarterFromBase
 *
 * @param {string} currentQuarter  
 * @param {string|Date|moment} [baseDate]  
 * @param {number} [daysPerQuarter=90]
 * @returns {string} 
 */
export function getQuarter(
	baseDate: string, 
	currentQuarter?: string | null , 
	daysPerQuarter = 90
) {
	if (!currentQuarter) {
		const now = moment();
		const q = Math.floor(now.month() / 3) + 1;
		const year = now.year();
		return `Q${q}/${year}`;
	}

  const cur = parseQuarterLabel(currentQuarter);
  const baseMoment = baseDate ? moment.utc(baseDate).startOf("day") : moment.utc().startOf("day");

  const baseQ = quarterFromMoment(baseMoment);
  const idxBase = baseQ.year * 4 + (baseQ.q - 1);
  const idxCur = cur.year * 4 + (cur.q - 1);
  const m = idxCur - idxBase; 

  if (m < 0) {
    return incrementQuarterLabel(currentQuarter, 1);
  }

  const stepsToAdd = m + 1;
  const futureMoment = baseMoment.clone().add(stepsToAdd * daysPerQuarter, "days");

  const nextQ = Math.floor(futureMoment.month() / 3) + 1;
  const nextYear = futureMoment.year();
  return `Q${nextQ}/${nextYear}`;
}
